import { render } from "./Confirm.vue?vue&type=template&id=3193837a&lang=pug"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=3193837a&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__